import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { propertyUiRoutes } from 'libs/property-ui/src/lib/property-ui-routes';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        children: propertyUiRoutes
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
